var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4, _react_refresh_temp_5;
var _react_refresh_temp_6;
_react_refresh_temp_6 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { store, useAppDispatch, useAppSelector } from '../../store';
import { updateIsActiveSharedNotePad } from '../../store/slices/bottomIconsActivitySlice';
const sharedNotepadFeaturesSelector = createSelector(_react_refresh_temp_1 = (state) => { var _a; return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features; }, (room_features) => room_features === null || room_features === void 0 ? void 0 : room_features.shared_note_pad_features);
$RefreshReg$(_react_refresh_temp_1, "sharedNotepadFeaturesSelector$createSelector");
const lockSharedNotepadSelector = createSelector(_react_refresh_temp_2 = (state) => { var _a, _b; return (_b = (_a = state.session.currentUser) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.lock_settings; }, (lock_settings) => lock_settings === null || lock_settings === void 0 ? void 0 : lock_settings.lock_shared_notepad);
$RefreshReg$(_react_refresh_temp_2, "lockSharedNotepadSelector$createSelector");
const themeSelector = createSelector(_react_refresh_temp_3 = (state) => state.roomSettings, (roomSettings) => roomSettings.theme);
$RefreshReg$(_react_refresh_temp_3, "themeSelector$createSelector");
const isActiveSharedNotePadSelector = createSelector(_react_refresh_temp_4 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.isActiveSharedNotePad);
$RefreshReg$(_react_refresh_temp_4, "isActiveSharedNotePadSelector$createSelector");
const SharedNotepadElement = () => {
    _react_refresh_temp_6();
    const sharedNotepadFeatures = useAppSelector(sharedNotepadFeaturesSelector);
    const lockSharedNotepad = useAppSelector(lockSharedNotepadSelector);
    const theme = useAppSelector(themeSelector);
    const isActiveSharedNotePad = useAppSelector(isActiveSharedNotePadSelector);
    const { i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const nodeRef = useRef(null);
    const currentUser = store.getState().session.currentUser;
    const [loaded, setLoaded] = useState();
    const [url, setUrl] = useState();
    const [currentPosition, setCurrentPosition] = useState(undefined);
    const getUserColor = () => {
        let userColor = sessionStorage.getItem('shared-notepad-user-color');
        if (!userColor) {
            userColor = ((Math.random() * 0xffffff) << 0)
                .toString(16)
                .padStart(6, '0');
            sessionStorage.setItem('shared-notepad-user-color', userColor);
        }
        return userColor;
    };
    useEffect(() => {
        if ((sharedNotepadFeatures === null || sharedNotepadFeatures === void 0 ? void 0 : sharedNotepadFeatures.is_active) && sharedNotepadFeatures.host) {
            let url = sharedNotepadFeatures.host;
            if (sharedNotepadFeatures.host.match('host.docker.internal')) {
                url = 'http://localhost:9001';
            }
            if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.isRecorder) {
                setUrl(`${url}/p/${sharedNotepadFeatures.read_only_pad_id}?userName=${currentUser === null || currentUser === void 0 ? void 0 : currentUser.name}`);
                return;
            }
            if (!lockSharedNotepad) {
                url = `${url}/p/${sharedNotepadFeatures.note_pad_id}?userName=${currentUser === null || currentUser === void 0 ? void 0 : currentUser.name}`;
            }
            else {
                url = `${url}/p/${sharedNotepadFeatures.read_only_pad_id}?userName=${currentUser === null || currentUser === void 0 ? void 0 : currentUser.name}`;
            }
            url += '&userColor=%23' + getUserColor() + '&lang=' + i18n.languages[0];
            if (theme === 'dark') {
                url += '&theme=monokai';
            }
            else {
                url += '&theme=normal';
            }
            setUrl(url);
        }
        else {
            setUrl(null);
        }
    }, [sharedNotepadFeatures, lockSharedNotepad, theme, i18n.languages]);
    const onLoad = () => {
        setLoaded(true);
    };
    const minimizePad = () => {
        dispatch(updateIsActiveSharedNotePad(false));
    };
    const onStopDrag = (_e, data) => {
        setCurrentPosition({ x: data.lastX, y: data.lastY });
    };
    return (_jsx(_Fragment, { children: url ? (_jsx("div", { className: isActiveSharedNotePad
                ? 'w-full notepadMainParent absolute h-full z-10 top-0 left-0 pointer-events-none'
                : 'hidden', children: _jsx("div", { className: "h-[calc(100%-50px)] mt-9 flex items-end justify-end", children: _jsx(Draggable, { handle: "#draggable-h1", nodeRef: nodeRef, onStop: onStopDrag, position: isActiveSharedNotePad ? currentPosition : { x: 0, y: 0 }, children: _jsxs("div", { className: "notepad-wrapper h-[calc(100%-80px)] w-full max-w-[400px] max-h-[500px] cursor-move relative pointer-events-auto", ref: nodeRef, children: [_jsx("div", { id: "draggable-h1", className: "absolute top-2 md:top-0 left-0 h-7 w-full text-white flex items-center justify-center text-sm" }), _jsx("div", { className: "hide-icon absolute pl-2 w-16 h-7 cursor-pointer flex items-center", onClick: minimizePad, children: _jsx("div", { className: "line h-0.5 w-6 bg-white" }) }), _jsxs("div", { className: "inner w-full h-full border-t-[28px] border-solid border-primaryColor", children: [!loaded ? (_jsx("div", { className: "loading absolute left-[50%] top-[40%] flex justify-center", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null, _jsx("iframe", { height: "100%", width: "100%", src: url, onLoad: onLoad })] })] }) }) }) })) : null }));
};
_react_refresh_temp_5 = SharedNotepadElement;
$RefreshReg$(_react_refresh_temp_5, "SharedNotepadElement");
_react_refresh_temp_6(SharedNotepadElement, "p5a4v/ObdyvOffBNODFPAMU79Zc=", false, () => [useAppSelector, useAppSelector, useAppSelector, useAppSelector, useTranslation, useAppDispatch]);
export default SharedNotepadElement;
